export const GET_USER_REQUEST = '[USERS] GET_USER_REQUEST'
export const GET_USER_SUCCESS = '[USERS] GET_USER_SUCCESS'
export const GET_USER_FAILED = '[USERS] GET_USER_FAILED'

export const GET_USER_LIST_REQUEST = '[USERS] GET_USER_LIST_REQUEST'
export const GET_USER_LIST_SUCCESS = '[USERS] GET_USER_LIST_SUCCESS'
export const GET_USER_LIST_FAILED = '[USERS] GET_USER_LIST_FAILED'

export const CREATE_USER_REQUEST = '[USERS] CREATE_USER_REQUEST'
export const CREATE_USER_SUCCESS = '[USERS] CREATE_USER_SUCCESS'
export const CREATE_USER_FAILED = '[USERS] CREATE_USER_FAILED'

export const EDIT_USER_REQUEST = '[USERS] EDIT_USER_REQUEST'
export const EDIT_USER_SUCCESS = '[USERS] EDIT_USER_SUCCESS'
export const EDIT_USER_FAILED = '[USERS] EDIT_USER_FAILED'

export const DELETE_USER_REQUEST = '[USERS] DELETE_USER_REQUEST'
export const DELETE_USER_SUCCESS = '[USERS] DELETE_USER_SUCCESS'
export const DELETE_USER_FAILED = '[USERS] DELETE_USER_FAILED'

export const USER_SEARCH_REQUEST = '[USERS] USER_SEARCH_REQUEST'
export const USER_SEARCH_SUCCESS = '[USERS] USER_SEARCH_SUCCESS'
export const USER_SEARCH_FAILED = '[USERS] USER_SEARCH_FAILED'

export const RESET_USER_FORM = '[USERS] RESET_USER_FORM';

// Test Actions... To Delete
export const GET_DATA_REQUEST = '[USERS] GET_DATA_REQUEST'
export const GET_DATA_SUCCESS = '[USERS] GET_DATA_SUCCESS'

export const SEARCH_REQUEST = '[USERS] SEARCH_REQUEST'
export const SEARCH_SUCCESS = '[USERS] SEARCH_SUCCESS'